import _ from 'lodash';
import './../sass/main.scss';

window.$ = window.jQuery = require('jquery');
window.bootstrap = require('bootstrap/dist/js/bootstrap.bundle.js');

require ('./typographer/jquery.typographer.min.pack.js');
require ('./typographer/hyph-pl.min.js');

require ('../../node_modules/slicknav/jquery.slicknav.js');

jQuery.noConflict();

jQuery(document).ready(function(){
	
	jQuery('body img').addClass('img-fluid');
	
	jQuery('body').typographer_orphan({
	  forbidden: ["a", "i", "o", "u", "w", "z", "oraz", "dla"]
	});
	
	var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
	var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
	  return new bootstrap.Popover(popoverTriggerEl)
	});
	
	var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
	var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
	  return new bootstrap.Tooltip(tooltipTriggerEl)
	});
	
	jQuery('#main-home').click(function() {
		jQuery(window).scrollTop();
	});
	
	jQuery("#main-menu-top-ul").slicknav({
		label: '',
		closeOnClick: true
	});
	jQuery('.slicknav_menu').prepend('<a href="https://www.grupapsb.com.pl" target="blank"><img src="../assets/media_and_docs/psb-mob.png" alt="Obrazek"></a>');
	
	//Sticky START
	
	//var stickyNavTop = $('.nav').offset().top;
	var stickyNavTop = 140;
		   	
	// our function that decides weather the navigation bar should have "fixed" css position or not.
	var stickyNav = function(){
		var mainScrollTop = jQuery(window).scrollTop(); // our current vertical position from the top

		// if we've scrolled more than the navigation, change its position to fixed to stick to top,
		// otherwise change it back to relative
		if (mainScrollTop > stickyNavTop) { 
			jQuery('#main-menu-top').addClass('main-menu-sticky');
		} else {
			jQuery('#main-menu-top').removeClass('main-menu-sticky'); 
		}
	};

	// and run it again every time you scroll
	jQuery(window).scroll(function() {
		stickyNav();
	});
	
	//Sticky STOP
	
	jQuery('#main-menu-top-ul > li, .slicknav_nav > li').click(function() {
		jQuery('#main-menu-top-ul > li > a, .slicknav_nav > li > a').removeClass('active');
		jQuery(this).find('a').addClass('active');
		var alink = jQuery(this).find('a').first().attr('href');
		var anchorPos = alink.lastIndexOf("#");
		var anchor = alink.substr(anchorPos);
		if(anchorPos != -1 && anchor != '#') {
			if(jQuery(anchor).length) {
				var aOffsetTop = jQuery(anchor).offset().top;
			    if(aOffsetTop >= 60) jQuery('html, body').animate({scrollTop: (aOffsetTop - 60)}, 'slow');
				else jQuery('html, body').animate({scrollTop: aOffsetTop}, 'slow');
		    }
	    } else {
			if(anchor == '#') jQuery('html, body').animate({scrollTop: 0}, 'slow');
		}
	});
	
	mainResize();
	
});

jQuery(window).resize(function() {
	mainResize();
});


//Funkcje

function mainResize() {
	var wwidth = jQuery(window).width();
    if (wwidth <= 950) {
		jQuery('#main-hero-block .main-hero-inside-two img').first().after(jQuery('#main-hero-block .main-btn-article').first());
		
	} else {
		jQuery('#main-hero-block .main-hero-inside-one').first().append(jQuery('#main-hero-block .main-btn-article').first());
	}
}

function placementObjectsAfter(element, elementAfter) {
	jQuery(elementAfter).after(jQuery(element));
}

function placementObjectsAppend(element, elementAppend) {
	jQuery(elementAppend).append(jQuery(element));
}

function placementObjectsPrepend(element, elementPrepend) {
	jQuery(elementPrepend).prepend(jQuery(element));
}